export const navigationLinks = [
  { label: '首页', href: '#hero' },
  { label: '平台特色', href: '#features' },
  { label: '今日瓜王排行榜', href: '#ranking' },
  { label: '瓜友热评', href: '#comments' },
  { label: '焦点深扒', href: '#carousel' },
];

export const heroData = {
  tag: '今日瓜王争霸 · 火热进行中',
  title: '每日大赛官网',
  subtitle: '每日吃瓜评选与爆料PK第一站',
  slogan: '一手吃瓜，全天候更新，围观娱乐圈最劲爆的八卦爆料',
  description: '每日大赛官网是全网最大的吃瓜评选与爆料PK平台。我们全天候追踪娱乐圈最新八卦动态，汇聚千万吃瓜群众的真实爆料，通过投票PK机制评选出每日最受欢迎的瓜王。无论是最新明星黑料、影视圈内幕，还是网红翻车现场，这里都有你最想扒的劲爆事件。加入每日大赛，成为资深吃瓜人，一手掌握娱乐圈风云变幻。',
  stats: [
    { label: '今日新增爆料', value: '2,847条' },
    { label: '实时在线吃瓜', value: '152,639人' },
    { label: '累计爆料总数', value: '128万+' },
  ],
  primaryCta: { label: '立即围观榜单', href: '#ranking' },
  secondaryCta: { label: '我要爆料', href: '#contact' },
};

export const updatesData = [
  {
    id: 1,
    time: '10分钟前',
    category: '明星恋情',
    title: '某顶流男星深夜密会神秘女子，两人同回公寓至凌晨三点',
    hot: true,
  },
  {
    id: 2,
    time: '28分钟前',
    category: '综艺翻车',
    title: '热门综艺录制现场爆发冲突，导演组紧急叫停拍摄',
    hot: true,
  },
  {
    id: 3,
    time: '1小时前',
    category: '影视爆料',
    title: '年度大制作疑似更换女主角，原定演员片酬纠纷曝光',
    hot: false,
  },
  {
    id: 4,
    time: '2小时前',
    category: '网红黑料',
    title: '千万粉丝网红被扒虚假人设，昔日同学集体爆料其真实面目',
    hot: true,
  },
  {
    id: 5,
    time: '3小时前',
    category: '音乐圈',
    title: '知名歌手新专辑被指抄袭，原创者发声要求下架并赔偿',
    hot: false,
  },
  {
    id: 6,
    time: '5小时前',
    category: '直播风波',
    title: '头部主播带货翻车现场直播，品牌方当场终止合作',
    hot: false,
  },
  {
    id: 7,
    time: '7小时前',
    category: '剧组内幕',
    title: '热播剧编剧与导演闹掰，续集拍摄计划全面搁置',
    hot: false,
  },
];

export const indexData = [
  {
    id: 1,
    icon: 'ri-fire-line',
    title: '今日瓜王',
    desc: '实时票选今日最受欢迎爆料',
    count: '32.6万票',
    color: 'primary',
  },
  {
    id: 2,
    icon: 'ri-sword-line',
    title: '爆料PK',
    desc: '两两对决选出最劲爆八卦',
    count: '186组对决',
    color: 'accent',
  },
  {
    id: 3,
    icon: 'ri-bar-chart-2-line',
    title: '吃瓜排行榜',
    desc: '本周最具话题性的瓜王排行',
    count: 'TOP 50',
    color: 'primary',
  },
  {
    id: 4,
    icon: 'ri-flashlight-line',
    title: '深扒专区',
    desc: '资深娱记深度挖掘内幕真相',
    count: '2,106篇',
    color: 'secondary',
  },
  {
    id: 5,
    icon: 'ri-chat-smile-2-line',
    title: '瓜友评论',
    desc: '吃瓜群众最犀利的评论合集',
    color: 'accent',
  },
  {
    id: 6,
    icon: 'ri-vidicon-line',
    title: '视频爆料',
    desc: '视频证据实锤，一眼看穿真相',
    color: 'primary',
  },
  {
    id: 7,
    icon: 'ri-user-voice-line',
    title: '匿名投稿',
    desc: '保护爆料人隐私，安全可靠',
    color: 'secondary',
  },
  {
    id: 8,
    icon: 'ri-trophy-line',
    title: '年度总榜',
    desc: '年度十大瓜王评选结果揭晓',
    color: 'accent',
  },
  {
    id: 9,
    icon: 'ri-thumb-up-line',
    title: '每日投票',
    desc: '为你支持的爆料投上关键一票',
    color: 'primary',
  },
];

export const commentsData = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20person%20portrait%20avatar%20in%20warm%20lighting%20casual%20style%20simple%20background%20editorial%20photography&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '吃瓜小能手',
    time: '2小时前',
    content: '这个瓜我追了三天了！男星那边一直没回应，女方倒是发了条意味深长的微博，感觉有反转。大家别急，让子弹飞一会儿。',
    likes: 2836,
    tag: '热门爆料',
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Chinese%20woman%20avatar%20with%20natural%20makeup%20warm%20studio%20lighting%20simple%20clean%20background&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '八卦研究所',
    time: '4小时前',
    content: '作为圈内人透露一下，这俩人早就有矛盾了，只是之前一直压着。这次爆出来只是冰山一角，后面还有更大的料等着呢。',
    likes: 5102,
    tag: '圈内爆料',
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20portrait%20avatar%20trendy%20style%20warm%20lighting%20soft%20background%20editorial&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '理中客吃瓜',
    time: '5小时前',
    content: '大家理性吃瓜。没有实锤证据之前，任何爆料都只是猜测。看看两边工作室怎么说再下结论吧，别被带节奏了。',
    likes: 1452,
    tag: '理性分析',
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20girl%20portrait%20avatar%20cute%20style%20natural%20light%20minimal%20background%20editorial%20photography&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '娱乐圈纪委',
    time: '7小时前',
    content: '笑死，这个投票太真实了。A选项已经领先B选项20万票了，群众的眼睛是雪亮的。我投A一票，坐等实锤。',
    likes: 8910,
    tag: '吃瓜PK',
  },
  {
    id: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20stylish%20Chinese%20person%20avatar%20warm%20tones%20casual%20look%20clean%20background%20editorial&width=80&height=80&seq=avatar-05&orientation=squarish',
    name: '瓜田守望者',
    time: '9小时前',
    content: '每日大赛的排行榜真的越来越有意思了。今天这个瓜的质量比昨天那个高太多了，年度瓜王候选预定。持续关注中！',
    likes: 3721,
    tag: '每日推荐',
  },
];

export const topicsData = [
  { id: 1, name: '明星恋情曝光', heat: '986万热度', icon: 'ri-heart-line' },
  { id: 2, name: '综艺现场翻车', heat: '823万热度', icon: 'ri-emotion-line' },
  { id: 3, name: '导演编剧纠纷', heat: '756万热度', icon: 'ri-film-line' },
  { id: 4, name: '网红人设崩塌', heat: '692万热度', icon: 'ri-user-smile-line' },
  { id: 5, name: '带货直播翻车', heat: '618万热度', icon: 'ri-live-line' },
  { id: 6, name: '新歌抄袭风波', heat: '534万热度', icon: 'ri-music-line' },
  { id: 7, name: '片酬天价争议', heat: '487万热度', icon: 'ri-money-cny-circle-line' },
  { id: 8, name: '剧组霸凌事件', heat: '421万热度', icon: 'ri-alert-line' },
  { id: 9, name: '颁奖典礼黑幕', heat: '398万热度', icon: 'ri-award-line' },
];

export const cardsData = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20scene%20with%20abstract%20spotlight%20on%20a%20red%20carpet%20entrance%20warm%20vermillion%20and%20gold%20tones%20artistic%20blur%20background%20editorial%20style&width=800&height=500&seq=card-01&orientation=landscape',
    category: '深度爆料',
    title: '娱乐圈"隐形富豪"排行榜：他一年光靠版税就赚了2个亿？',
    excerpt: '看似低调的艺人背后，隐藏着令人咋舌的商业帝国。我们深扒了十位最会赚钱的明星副业，结果远超你的想象...',
    author: '深扒编辑部',
    time: '3小时前',
    reads: '12.8万',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Film%20set%20behind%20the%20scenes%20with%20cameras%20and%20lighting%20equipment%20warm%20dramatic%20atmosphere%20motion%20blur%20artistic%20editorial%20photography&width=800&height=500&seq=card-02&orientation=landscape',
    category: '剧组揭秘',
    title: '热播剧导演独家回应：女主角换角内幕终于水落石出',
    excerpt: '关于这部年度大剧的女主角换角风波，导演在最新采访中首次正面回应。真相远比传闻更加复杂...',
    author: '前线娱记',
    time: '5小时前',
    reads: '9.6万',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20modern%20studio%20with%20microphone%20and%20recording%20equipment%20warm%20golden%20lighting%20creative%20atmosphere%20artistic%20composition&width=800&height=500&seq=card-03&orientation=landscape',
    category: '音乐内幕',
    title: '原创者发声！热门单曲疑似抄袭事件全时间线梳理',
    excerpt: '从歌曲发行到原创者维权，我们整理了这起抄袭风波的关键节点。双方的证据和说法，这里全都有...',
    author: '音乐观察员',
    time: '8小时前',
    reads: '7.3万',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20with%20product%20display%20desk%20warm%20dramatic%20lighting%20chaotic%20atmosphere%20artistic%20blur%20editorial%20style&width=800&height=500&seq=card-04&orientation=landscape',
    category: '直播观察',
    title: '头部主播集体翻车？直播带货行业信任危机全面爆发',
    excerpt: '一个月内连续三起主播翻车事件，品牌方损失惨重。我们盘点了最严重的十起直播翻车事故...',
    author: '消费调查组',
    time: '12小时前',
    reads: '15.1万',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Award%20ceremony%20stage%20with%20spotlights%20and%20empty%20seats%20dramatic%20warm%20lighting%20mysterious%20atmosphere%20cinematic%20editorial%20photography&width=800&height=500&seq=card-05&orientation=landscape',
    category: '颁奖黑幕',
    title: '年度颁奖礼票数疑云：最佳男主角奖项存在暗箱操作？',
    excerpt: '多位业内人士爆料，某大型颁奖典礼的投票系统存在严重漏洞。获奖结果与观众预期严重不符...',
    author: '业内知情人',
    time: '1天前',
    reads: '20.3万',
  },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-shield-check-line',
    title: '权威爆料审核',
    desc: '每条爆料经过编辑团队审核，确保信息真实性。虚假爆料将被标记并下架，保护吃瓜体验。',
  },
  {
    id: 2,
    icon: 'ri-group-line',
    title: '千万瓜友社区',
    desc: '汇聚全网最爱吃瓜的用户，在这里你能找到志同道合的吃瓜伙伴，一起讨论最新八卦。',
  },
  {
    id: 3,
    icon: 'ri-speed-up-line',
    title: '实时快讯推送',
    desc: '24小时不间断追踪娱乐圈动态，重大爆料事件15分钟内即可上线，让你永远快人一步。',
  },
  {
    id: 4,
    icon: 'ri-survey-line',
    title: '公正投票机制',
    desc: '一人一票制确保评选公平，反作弊系统拦截刷票行为。每月瓜王由真实用户投票产生。',
  },
  {
    id: 5,
    icon: 'ri-lock-line',
    title: '匿名爆料保护',
    desc: '采用银行级加密技术保护爆料人身份信息。我们绝不透露爆料人资料，让你安心投稿。',
  },
];

export const carouselData = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20red%20carpet%20scene%20with%20paparazzi%20flashes%20celebrity%20silhouette%20warm%20vermillion%20and%20golden%20lighting%20cinematic%20atmosphere%20artistic%20blur&width=900&height=600&seq=carousel-01&orientation=landscape',
    tag: '本周最热',
    title: '年度最大反转：被群嘲的艺人如何用一部作品让所有人闭嘴',
    desc: '从全网嘲讽到口碑逆转，这位艺人的翻身仗打得漂亮。我们复盘了整个事件的来龙去脉，以及那些被忽略的关键细节。',
    link: '#carousel',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Film%20production%20set%20with%20director%20chair%20and%20camera%20dramatic%20warm%20lighting%20behind%20the%20scenes%20atmosphere%20cinematic%20editorial&width=900&height=600&seq=carousel-02&orientation=landscape',
    tag: '深度调查',
    title: '娱乐圈"塌房"经济学：一个顶流倒下，背后谁在赚钱？',
    desc: '当一位顶流艺人翻车，品牌解约、剧集下架、综艺删减——表面是损失，暗地里却有人从中牟利。深扒娱乐圈的灰色产业链。',
    link: '#carousel',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20stage%20performance%20with%20spotlight%20effects%20dramatic%20warm%20gold%20and%20amber%20lighting%20motion%20blur%20artistic%20editorial&width=900&height=600&seq=carousel-03&orientation=landscape',
    tag: '独家揭秘',
    title: '你不知道的综艺选角内幕：那些被剪辑"制造"出来的冲突',
    desc: '一位前综艺编导匿名爆料：你所看到的"冲突"和"争执"，90%都是后期剪辑的结果。真人秀到底有多真？',
    link: '#carousel',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20studio%20with%20ring%20light%20and%20camera%20setup%20warm%20dramatic%20atmosphere%20dark%20mood%20cinematic%20editorial&width=900&height=600&seq=carousel-04&orientation=landscape',
    tag: '数据解密',
    title: '粉丝打投数据大起底：那些天价应援背后隐藏的惊人真相',
    desc: '我们分析了近一年来的粉丝应援数据，发现其中存在大量异常。天价礼物、刷量打榜，粉丝经济的泡沫何时破？',
    link: '#carousel',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Music%20recording%20studio%20with%20instruments%20and%20mixing%20console%20warm%20amber%20lighting%20creative%20atmosphere%20cinematic%20depth%20editorial&width=900&height=600&seq=carousel-05&orientation=landscape',
    tag: '行业观察',
    title: '音乐版权争夺战：一首热门歌曲背后的利益纠葛有多复杂？',
    desc: '从词曲作者到唱片公司，再到流媒体平台，一首歌的版权链比大多数人想象的复杂得多。我们揭开这个行业的利益版图。',
    link: '#carousel',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Empty%20theater%20stage%20with%20dramatic%20curtain%20and%20spotlight%20warm%20golden%20lighting%20mysterious%20atmosphere%20cinematic%20artistic%20editorial&width=900&height=600&seq=carousel-06&orientation=landscape',
    tag: '年度盘点',
    title: '2026上半年娱乐圈大事件回顾：那些改变行业格局的关键时刻',
    desc: '从年初的颁奖风波到最近的直播翻车潮，这半年娱乐圈发生了太多值得记录的事件。我们按时间线一一梳理。',
    link: '#carousel',
  },
];

export const mediaData = [
  {
    id: 1,
    thumbnail: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20style%20dramatic%20press%20conference%20scene%20with%20microphones%20warm%20lighting%20cinematic%20composition%20play%20button%20overlay%20style&width=640&height=360&seq=media-01&orientation=landscape',
    title: '独家视频：顶流男星被拍到与神秘女子同回公寓全过程',
    duration: '03:24',
    views: '89.2万',
    tag: '独家',
  },
  {
    id: 2,
    thumbnail: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20style%20reality%20show%20set%20with%20hosts%20arguing%20dramatic%20warm%20lighting%20cinematic%20tension&width=640&height=360&seq=media-02&orientation=landscape',
    title: '综艺录制现场冲突视频流出，导演喊暂停后场面一度失控',
    duration: '05:18',
    views: '67.8万',
    tag: '热播',
  },
  {
    id: 3,
    thumbnail: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20style%20live%20streaming%20setup%20with%20products%20on%20desk%20dramatic%20moment%20warm%20lighting%20chaotic&width=640&height=360&seq=media-03&orientation=landscape',
    title: '直播翻车现场完整版：主播说错品牌名，品牌方当场离席',
    duration: '12:06',
    views: '156.3万',
    tag: '爆款',
  },
  {
    id: 4,
    thumbnail: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20style%20award%20ceremony%20stage%20with%20spotlight%20dramatic%20moment%20warm%20golden%20atmosphere%20cinematic&width=640&height=360&seq=media-04&orientation=landscape',
    title: '颁奖典礼观众席偷拍：获奖者面部表情微妙变化全记录',
    duration: '02:45',
    views: '43.1万',
    tag: '热门',
  },
  {
    id: 5,
    thumbnail: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20style%20music%20recording%20studio%20session%20with%20singer%20and%20producer%20warm%20creative%20atmosphere%20cinematic&width=640&height=360&seq=media-05&orientation=landscape',
    title: '录音室档期争夺：两位顶流歌手为抢录音棚差点打起来',
    duration: '01:52',
    views: '35.7万',
    tag: '趣闻',
  },
];

export const appData = {
  title: '随时随地，一手吃瓜',
  desc: '下载每日大赛App，不错过任何劲爆爆料。手机端专属推送，让你永远快人一步。打开微信扫一扫，立即加入千万瓜友社区！',
  image: 'https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20a%20news%20feed%20style%20app%20interface%20with%20Chinese%20text%20and%20entertainment%20news%20cards%20warm%20vermillion%20and%20cream%20color%20scheme%20clean%20minimal%20design%20on%20light%20background&width=600&height=800&seq=app-mockup&orientation=portrait',
  features: ['实时推送爆料快讯', '专属投票PK通道', '匿名投稿更安全', '瓜友社区互动'],
};

export const aboutData = {
  title: '关于每日大赛',
  content: '每日大赛官网创立于2023年，是国内领先的娱乐八卦吃瓜评选平台。我们致力于打造一个公开、公正、透明的吃瓜社区，让每一位用户都能参与娱乐事件的讨论与评选。平台累计注册用户超过800万，日均活跃吃瓜用户超过150万，已成为娱乐圈爆料事件最重要的舆论场之一。\n\n我们的编辑团队由资深娱记、媒体人和数据分析师组成，全天候追踪娱乐圈最新动态，确保每一条信息的时效性和准确性。同时，我们的投票系统采用先进的反作弊技术，保证每次评选结果的真实可信。',
  stats: [
    { label: '注册用户', value: '800万+' },
    { label: '日均爆料', value: '2,800+' },
    { label: '月均投票', value: '5,600万' },
    { label: '合作媒体', value: '200+' },
  ],
};

export const contactData = {
  title: '爆料投稿',
  subtitle: '你有独家内幕？快来投稿！我们保护每一位爆料人的隐私安全。',
  channels: [
    { icon: 'ri-mail-line', label: '投稿邮箱', value: 'tougao@meiridasai.com' },
    { icon: 'ri-wechat-line', label: '微信投稿', value: 'meiridasai_tg' },
    { icon: 'ri-shield-user-line', label: '匿名保护', value: '银行级加密，绝不泄露爆料人信息' },
  ],
};

export const faqData = [
  {
    id: 1,
    question: '每日大赛的投票规则是什么？',
    answer: '每位注册用户每天可以在每个PK对决中投出1票。投票采用一人一票制，系统会自动检测异常投票行为。每天零点更新投票数据，并结算前一天的瓜王排名。新用户注册即送3张额外投票卡，可用于你特别关注的爆料PK。',
  },
  {
    id: 2,
    question: '如何保证爆料的真实性？',
    answer: '我们建立了严格的三级审核机制。第一级由AI自动过滤明显虚假信息；第二级由编辑团队人工核实关键细节；第三级是交叉验证，如果多个独立来源提供相似信息，可信度评级会更高。被证实为虚假的爆料会被标注"不实"并降低曝光权重。',
  },
  {
    id: 3,
    question: '爆料投稿后会泄露个人信息吗？',
    answer: '绝对不会。我们采用银行级AES-256加密技术保护所有投稿人的身份信息。投稿系统不记录IP地址，投稿内容经过脱敏处理后才会进入审核流程。我们承诺在任何情况下都不会向第三方透露爆料人的任何信息，这是我们的底线。',
  },
  {
    id: 4,
    question: '吃瓜排行榜的排名是如何计算的？',
    answer: '排行榜综合了多个维度：用户投票数（权重40%）、评论热度（权重25%）、分享转发量（权重20%）、编辑推荐指数（权重15%）。系统每小时更新一次排名，每日瓜王在当晚24点最终确定。所有数据公开透明，用户可在排名详情页查看完整计算过程。',
  },
  {
    id: 5,
    question: '发现有侵权或不实内容怎么办？',
    answer: '我们非常重视内容合规。如果你发现任何涉及侵权、诽谤或不实的内容，可以通过页面底部的"侵权投诉"链接提交申诉，或直接发送邮件至copyright@meiridasai.com。我们的法务团队会在24小时内响应，核实属实的内容将在2小时内下架处理。',
  },
];

export const rankingData = [
  {
    id: 1,
    rank: 1,
    title: '顶流男星深夜密会神秘女子',
    category: '明星恋情',
    votes: '328,562票',
    trend: 'up',
    change: '+12.5%',
    hot: true,
  },
  {
    id: 2,
    rank: 2,
    title: '千万网红被扒虚假人设',
    category: '网红曝光',
    votes: '295,108票',
    trend: 'up',
    change: '+8.3%',
    hot: true,
  },
  {
    id: 3,
    rank: 3,
    title: '综艺录制现场导演与嘉宾爆发冲突',
    category: '综艺翻车',
    votes: '261,734票',
    trend: 'up',
    change: '+15.1%',
    hot: false,
  },
  {
    id: 4,
    rank: 4,
    title: '年度大制作女主角因片酬纠纷换人',
    category: '影视爆料',
    votes: '218,906票',
    trend: 'down',
    change: '-3.2%',
    hot: false,
  },
  {
    id: 5,
    rank: 5,
    title: '头部主播带货翻车品牌当场解约',
    category: '直播风波',
    votes: '195,372票',
    trend: 'up',
    change: '+22.7%',
    hot: true,
  },
];

export const footerData = {
  slogan: '每日大赛官网 - 全网最大的吃瓜评选与爆料PK平台',
  description: '每日大赛官网是集吃瓜评选、爆料PK、瓜王排行榜于一体的娱乐八卦平台。我们全天候追踪娱乐圈最新动态，为千万吃瓜群众提供一手八卦资讯。客观公正的投票机制，让每一条爆料的真实价值由用户共同评判。',
  links: [
    {
      title: '热门频道',
      items: [
        { label: '吃瓜排行榜', href: '#ranking' },
        { label: '爆料PK', href: '#index' },
        { label: '深扒专区', href: '#carousel' },
        { label: '视频爆料', href: '#media' },
      ],
    },
    {
      title: '关于我们',
      items: [
        { label: '平台介绍', href: '#about' },
        { label: '常见问题', href: '#faq' },
        { label: '爆料投稿', href: '#contact' },
        { label: '侵权投诉', href: '#contact' },
      ],
    },
    {
      title: '合作伙伴',
      items: [],
    },
  ],
};